import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";
import AlertContext from "../context/alert/AlertContext";
import ConfigContext from "../context/config/ConfigContext";

const useTokenCheck = () => {
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const configContext = useContext(ConfigContext);
  const { getConfigValueByCode } = configContext;
  const { token, isValidating, validateUserToken, logout } = authContext;
  const { clearAlerts, setAlert } = alertContext;
  const [isValid, setIsValid] = useState();
  const history = useHistory();

  const hasTokenExpired = () => {
    setIsValid();
    console.log("TOKEN CHECK");
    const checkValidity = async () => {
      try {
        const validity = await validateUserToken(token);
        console.log("isValid:", validity);
        setIsValid(validity);
      } catch (err) {
        console.log(err);
        console.log("Err isValid:", false);
        setIsValid(false);
        logout();
        history.push("/");
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 464);
        setAlert(msg, "danger");
      }
    };
    checkValidity();

    return;
  };

  useEffect(() => {
    if (isValid === false) {
      console.log("isValid ", isValid, " and isValidating ", isValidating);
      logout();
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid]);

  return { hasTokenExpired };
};

export default useTokenCheck;
